import { BreakpointObserver } from "@angular/cdk/layout";
import { Injectable } from "@angular/core";
import { OBSERVER_BREAKPOINT_MD_MAX } from "src/app/constants/technical.constants";
import { FmsService } from "src/app/services/fms.service";
import { TourManager, TourService } from "src/app/services/tour.service";

@Injectable({ providedIn: "root" })
export class PensionPlanTourService implements TourManager {
  constructor(
    private readonly tourService: TourService,
    private readonly fmsService: FmsService,
    private readonly breakpointObserver: BreakpointObserver,
  ) {}

  public async startTour(): Promise<void> {
    this.tourService.startTour([
      {
        id: "pensionPlanStartAge",
        selector: this.getIsMobile()
          ? "app-simulation-params-activator button"
          : "app-simulation-history-card stb-form select",
        position: this.getIsMobile() ? "top" : "right",
        title: this.fmsService.instant("pensionPlan.tour.startAge.title"),
        text: this.fmsService.instant("pensionPlan.tour.startAge.text"),
      },
      {
        id: "pensionPlanContinueInPlan",
        selector: "app-nav-progress .button-next",
        position: "top",
        title: this.fmsService.instant("pensionPlan.tour.nextButton.title"),
        text: this.fmsService.instant("pensionPlan.tour.nextButton.text"),
      },
    ]);
  }

  public stopTour(): void {
    this.tourService.stopTour();
  }

  private getIsMobile(): boolean {
    return this.breakpointObserver.isMatched(OBSERVER_BREAKPOINT_MD_MAX);
  }
}
